.content-button {
	margin-top: rem(60);
}

#mylivewell img {
	max-width: 20%;

	@include min(768px) {
		max-width: 100%;
	}
}